import { render, staticRenderFns } from "./custConvertInstallList.vue?vue&type=template&id=4b8478d6&scoped=true&"
import script from "./custConvertInstallList.vue?vue&type=script&lang=js&"
export * from "./custConvertInstallList.vue?vue&type=script&lang=js&"
import style0 from "./custConvertInstallList.vue?vue&type=style&index=0&id=4b8478d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8478d6",
  null
  
)

export default component.exports